import { FormControl } from "@angular/forms";

import { IProductExtended } from "@shared/interfaces";

export namespace ReportsEudrModel {
  export enum ActivityEnum {
    DOMESTIC = "DOMESTIC",
    IMPORT = "IMPORT",
    EXPORT = "EXPORT",
  }

  export enum ReportCustomFieldEnum {}

  export const noGPSDataValue = $localize`:@@shared.none:None`;
  export const operatorSectionText = $localize`:@@eudr.euisinformation.help:Information depends on which data you have in the EU IS system.`;

  export const requiredProductFields: Array<keyof IProductExtended> = ["hsCode"];

  export type requiredCustomFieldValue = string;
  export type RequiredCustomFieldValues = {
    [label in ReportCustomFieldEnum]: requiredCustomFieldValue;
  };

  export interface IProductWithCustomFieldsValueToGroup {
    product: IProductExtended;
    customFieldValuesToGroup: string[];
  }

  export interface IHsCode {
    hscode: string | number;
    description: string;
  }

  // Native material properties are now used instead of custom fields
  export enum MaterialPropertyEnum {
    SCIENTIFIC_NAME = "Scientific name",
    COMMON_NAME = "Common name",
  }

  export interface ReferenceFormData {
    referenceNumber: FormControl<string>;
    verificationNumber: FormControl<string>;
  }

  export const hsCodesJsonPath = "/assets/data/hs_codes.json";

  export const ddsSavedSuccessMessage = $localize`:@@eudr.eudrduediligencestatementsaved:EUDR due diligence statement saved`;
}
